/*
 * Root A fix (п.1 / п.5 CRO) — terms-gate без alert().
 * Заміна: alert() -> видима inline-помилка біля чекбокса + підсвітка + автоскрол + фокус.
 * Помилка зникає, щойно користувач відмічає галочку.
 * Зберігає переклади (theme.strings.cartTermsConfirmation). Нуль залежності від додатків.
 * Drop-in заміна assets/cart-terms.js. Revert = відновити оригінал (27 рядків).
 */
if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
      this.changeHandler = this.handleChange.bind(this);
      this.cartTermsCheckbox.addEventListener('change', this.changeHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
      this.cartTermsCheckbox.removeEventListener('change', this.changeHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        this.showError();
      }
    }

    /** Clears the error once the customer ticks the checkbox. */
    handleChange() {
      if (this.cartTermsCheckbox.checked) this.hideError();
    }

    showError() {
      let msg = this.querySelector('.js-cart-terms-error');
      if (!msg) {
        msg = document.createElement('div');
        msg.className = 'cart-terms__error js-cart-terms-error';
        msg.setAttribute('role', 'alert');
        msg.setAttribute('aria-live', 'assertive');
        msg.textContent = theme.strings.cartTermsConfirmation;
        msg.style.cssText = 'color:#b00020;font-size:.85em;line-height:1.3;margin-top:6px;font-weight:600;';
        this.appendChild(msg);
      }
      this.cartTermsCheckbox.style.outline = '2px solid #b00020';
      this.cartTermsCheckbox.style.outlineOffset = '2px';
      this.cartTermsCheckbox.setAttribute('aria-invalid', 'true');
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.cartTermsCheckbox.focus();
    }

    hideError() {
      this.cartTermsCheckbox.style.outline = '';
      this.cartTermsCheckbox.style.outlineOffset = '';
      this.cartTermsCheckbox.removeAttribute('aria-invalid');
      const msg = this.querySelector('.js-cart-terms-error');
      if (msg) msg.remove();
    }
  }
  customElements.define('cart-terms', CartTerms);
}
